const timeTextFromMinutes = (minutes) => {
  return `${Math.max(minutes - 10, 10)} - ${minutes + 10} min`;
};

export default timeTextFromMinutes;
